import React from 'react';
import PropTypes from 'prop-types';
import { PlanData, PlanKind } from '../../types';
import styled, { css } from 'styled-components';
import { div, palette } from '../../constants/styles';
import { IoLockClosed, IoLockOpen } from "react-icons/io5";
import { useDispatch } from 'react-redux';
import { downloadPlan } from '../../actions/plan';

const propTypes = {};

const defaultProps = {};

type Props = {
  plan_type: string,
  user_name: string,
  plans: PlanData[]
};

const StyledFlex = styled.div`
display: flex;
align-items: center;
justify-content: center;

`;

const PlanLink = div` 
border-radius: 50%;
color: white;
width: 40px;
height: 40px;
cursor: pointer;
display: flex;
justify-content: center;
align-items: center;
margin: 0 10px;
${({ backgroundColor }) => backgroundColor && css`
background-color: ${backgroundColor};
`}

`;

const fromPlanKind = (kind: PlanKind) => {
  switch (kind) {
    case 'blocked':
      return <IoLockClosed color="#ffffff" size={25} />
    case 'unblocked':
      return <IoLockOpen color="#ffff" size={25} />
  }
}

const bgColors = [palette.sweetPurple, palette.someBlue]

export default function DownloadPlanComponent({ plan_type, user_name, plans } : Props) {
  console.log(Object.values(plans));
  const dispatch = useDispatch();
  const downloadPlanAction = (plan: PlanData, user_name: string, plan_type: string) => dispatch(
      downloadPlan(plan, user_name, plan_type)
  );
  
  return (
    <StyledFlex>
      {
        Object.values(plans).map((plan, idx) => (
            <PlanLink
              key={idx}
              backgroundColor={bgColors[idx % bgColors.length]}
              onClick={() => downloadPlanAction(plan, user_name, plan_type)}
            >
              {fromPlanKind(plan.type)}
            </PlanLink>
        ))
      }
    </StyledFlex>
  );
}

DownloadPlanComponent.propTypes = propTypes;
DownloadPlanComponent.defaultProps = defaultProps;